import React, { useState } from "react";
import {
  Popover,
  Chip,
  Icon,
  Typography,
  CircularLoader,
  Modal,
  Button,
} from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
import StyledChip from "../../../../../components/styled/Chip";

const StyledTypography = styled(Typography).attrs()`
  font-weight: 500;
`;

const DownloadReports = ({
  downloadReport,
  preparingToDownload = false,
  count = 0,
  loading,
  maxDownloadRows,
  employee_email,
  chipProps = {},
  reportsData,
  isReportLoading,
  hideReportOptions,
}) => {
  const [showEmailConfirmationPopup, setShowEmailConfirmationPopup] =
    useState(false);
  const [selected, setSelected] = useState(false);
  const isDisabled = hideReportOptions;
  return (
    <div>
      <Popover
        onVisibilityChange={(data) => {
          setSelected(data);
        }}
        content={
          isDisabled ? (
            ""
          ) : loading ? (
            <CircularLoader size="xs" color="base" className="py-12 px-24" />
          ) : (
            <div className="d-flex align-items-center py-12 px-24">
              <Icon
                iconName="PlumFile"
                size="s"
                color="text"
                shade="c04"
                className="mr-8 d-flex align-items-center"
              />
              <Typography color="text" shade="c04" className="mb-0">
                {`${count} Records `}
              </Typography>
              {preparingToDownload ? (
                <>
                  <Typography.HelperText
                    color="dark"
                    shade="c200"
                    className="ml-56 mb-0 mr-4"
                  >
                    Preparing
                  </Typography.HelperText>
                  <CircularLoader size="xs" color="base" />
                </>
              ) : count > 0 ? (
                <Typography.ButtonText
                  className="ml-56 mb-0 cursor-pointer"
                  color="primary"
                  shade="c03"
                  onClick={() => {
                    if (maxDownloadRows && maxDownloadRows < count) {
                      setShowEmailConfirmationPopup(true);
                      document.body.click();
                    } else {
                      downloadReport();
                    }
                  }}
                >
                  Download
                </Typography.ButtonText>
              ) : (
                <CircularLoader className="ml-12" />
              )}
            </div>
          )
        }
        offset={[0, 16]}
        placement="bottom-end"
      >
        <StyledChip
          {...chipProps[selected ? "active" : "unactive"]}
          label="Download"
          textColor="dark"
          textShade="c300"
          size="medium"
          className="ml-12 pl-8"
          disabled={isDisabled}
          zIndex={-1}
          onOverlayClick={() => {
            return;
          }}
          id="reports-download-btn"
          avatar={
            <div className="pl-2">
              <Icon iconName="Download" size={16} />
            </div>
          }
        />
      </Popover>
      <Modal
        isOpen={showEmailConfirmationPopup}
        onClose={() => {
          setShowEmailConfirmationPopup(false);
        }}
        disableCloseButton={false}
        timeout={0}
        className="d-flex justify-content-center align-items-center"
      >
        <div>
          <Typography.H2>Send report to email</Typography.H2>
          <Typography className="mt-12">
            As the number of records is more than {maxDownloadRows}, the report
            will be sent to the email ID {employee_email}. Do you want to
            proceed?
          </Typography>
          <div className="d-flex justify-content-end">
            <Button
              color="primary"
              variant="fill"
              onClick={() => {
                downloadReport();
                setShowEmailConfirmationPopup(false);
              }}
            >
              Ok
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DownloadReports;
